import type { ComponentType } from 'react';
import {
  Home16,
  Help16,
  Performance16,
  Report16,
  WhitePaper16,
  Multi16,
  Function16,
  Participants16,
} from '@toptal/picasso-icons';
import { ROUTES } from '@/constants/routes';
import { clearAssessmentsListState } from '@/hooks/useAssessmentsListState';

export type NavItem = {
  to: string;
  label: string;
  icon: typeof Home16;
  end?: boolean;
  // Fired when the item is clicked. Entering the assessments list from the menu
  // resets its preserved expand/scroll state (see assessmentsListState.ts).
  onSelect?: () => void;
};

export type NavSection = {
  heading?: string;
  items: NavItem[];
};

export const ADMIN_NAV: NavSection[] = [
  {
    items: [
      {
        to: ROUTES.admin(),
        label: 'Assessments',
        icon: WhitePaper16,
        end: true,
        onSelect: () => clearAssessmentsListState(),
      },
    ],
  },
  {
    heading: 'ASSESSMENT SETUP',
    items: [
      { to: ROUTES.adminFrameworks(), label: 'Frameworks', icon: Multi16 },
      { to: ROUTES.adminDomains(), label: 'Domains', icon: Function16 },
      { to: ROUTES.adminIndustryBenchmarks(), label: 'Industry Benchmarks', icon: Performance16 },
    ],
  },
  {
    heading: 'USER ACCESS',
    items: [{ to: ROUTES.adminUsers(), label: 'User Management', icon: Participants16 }],
  },
];

export const CONSULTANT_NAV: NavSection[] = [
  {
    items: [
      {
        to: ROUTES.assessments(),
        label: 'Assessments',
        icon: WhitePaper16,
        onSelect: () => clearAssessmentsListState(),
      },
    ],
  },
];
